import { GRAPHQL_ENDPOINT, SITE } from "@api/constants";
import removeProductFromCartMutation from "@api/mutations/remove-product-from-cart";
import Cart from "@api/types/cart";
import RemoveProduct from "@api/types/remove-product";

type MutationResult = {
  data: {
    cart: {
      remove: {
        cart: Cart;
      };
    };
  };
};

/**
 * Add a product to cart.
 */
const removeProductFromCart = async (token: string, input: RemoveProduct): Promise<Cart> => {
  const body = {
    query: removeProductFromCartMutation,
    variables: {
      input,
    },
  };

  const response = await fetch(GRAPHQL_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CORE-SITE": SITE,
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(body),
  });
  const responseBody = (await response.json()) as MutationResult;
  return responseBody?.data.cart.remove.cart;
};

export default removeProductFromCart;
